import React, { createContext, useContext } from 'react';
import { LISTING_TEST_AA_SSR_EXPERIMENT } from '../../experimentation/constants';
import type { Experimentation } from '../../types';
import { SSRExperimentation } from './types';

export const SSRExperimentationContext = createContext<SSRExperimentation>({
    experiments: {
        test_aa_ssr: false,
    },
    isSSRExperimentationEnabled: false,
});
SSRExperimentationContext.displayName = 'SSRExperimentationContext';

export const useSSRExperimentContext = (): SSRExperimentation => {
    const value = useContext(SSRExperimentationContext);

    if (!value) {
        throw new Error(
            'useSSRExperimentationContext must be used within SSRExperimentationContext',
        );
    }

    return value;
};

export const SSRExperimentationProvider: React.FC<{
    value?: Experimentation;
}> = ({
    children,
    value: { activeSSRExperiments, isSSRExperimentationEnabled = false } = {},
}) => {
    const testAASsrValue =
        activeSSRExperiments === undefined
            ? false
            : activeSSRExperiments.includes(
                  LISTING_TEST_AA_SSR_EXPERIMENT.experimentName,
              );

    return (
        <SSRExperimentationContext.Provider
            value={{
                experiments: {
                    test_aa_ssr: testAASsrValue,
                },
                isSSRExperimentationEnabled,
            }}
        >
            {children}
        </SSRExperimentationContext.Provider>
    );
};
